import { FormConfig } from 'src/app/shared/models/dynamic.model';

const commonProps = {
  type: 'input',
  required: false,
};

export const advancedSearchBagsFormFieldsConfig: FormConfig = {
  fields: [
    {
      ...commonProps,
      id: 'bag',
      label: 'Bag',
    },
    {
      ...commonProps,
      id: 'origin',
      label: 'Origin',
    },
    {
      ...commonProps,
      id: 'destination',
      label: 'Destination',
    },
  ],
};

export interface BagsModal {
  bag: string;
  origin: string;
  destination: string;
}

export const defaultBagsModal: BagsModal = {
  bag: '',
  origin: '',
  destination: '',
};

export interface BagModalStateModel {
  detailModal: BagsModal;
}

// Initial state
export const defaultBagState: BagModalStateModel = {
  detailModal: defaultBagsModal,
};